import React from 'react';

interface LateramMenuProps {
  children: any,
}

function LateralMenu({
  children,
}: LateramMenuProps) {
  return (
    <div className="component-lateral-menu">
      {
        children
      }
    </div>
  );
}

export default LateralMenu;
